<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 智慧安防上 -->
      <el-row>
        <el-col :span="24" class="scene_top">
          <div class="scene_topContent">
            <h1>智慧安防</h1>
            <ul>
              <li>主动预警</li>
              <li>多系统联动</li>
              <li>提升运营效率</li>
            </ul>
          </div>
          <div class="security_picture">
            <img src="~@/assets/images/intelligentSecurity6.png" />
          </div>
        </el-col>
      </el-row>
      <!-- 业务痛点 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space scene_park">
            <div class="title">
              <h3>业务痛点</h3>
            </div>
            <el-row>
              <el-col :span="8">
                <div class="content" style="padding-right: 12%">
                  <h4 style="margin-bottom: 13px !important">
                    被动防范，体验和使用效果差
                  </h4>
                  <p>无预警、预防、预测机制，误报现象严重，只能事后取证</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content_picture">
                  <img src="~@/assets/images/intelligentSecurity3.png" />
                </div>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <div
                    class="content"
                    style="text-align: left; padding-left: 25%"
                  >
                    <h4 style="margin-bottom: 13px !important">
                      效率低，一团守一楼
                    </h4>
                    <p>人员效率低，成本居高不下</p>
                  </div>
                </el-row>
                <el-row>
                  <div
                    class="content"
                    style="text-align: left; padding-left: 25%"
                  >
                    <h4 style="margin-bottom: 13px !important">
                      单机版，无法联动其他系统
                    </h4>
                    <p>缺乏针对性场景化方案，无法跟其他设备有效联动</p>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 核心功能 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space hexing">
            <div class="title">
              <h3>核心功能</h3>
            </div>
            <el-row>
              <el-col :span="8">
                <div class="content contentHit">
                  <div class="content_picture">
                    <img src="~@/assets/images/intelligentSecurity2.png" />
                  </div>
                  <h4>智能监控</h4>
                  <p>
                    实时在线，可跟可控 实现对周界、公共区域全方位 可视化管理
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <div class="content_picture">
                    <img src="~@/assets/images/intelligentSecurity4.png" />
                  </div>
                  <h4>智能布防</h4>
                  <p>周界防卫与视频联动 布控主动预警异常、入侵</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <div class="content_picture">
                    <img src="~@/assets/images/intelligentSecurity5.png" />
                  </div>
                  <h4>数字巡逻</h4>
                  <p>实时轨迹跟踪 异常同步告警，有效结合</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    background: url(~@/assets/images/intelligentSecurity1.png) no-repeat;
    background-size: 100% 100%;
    height: 475px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      position: absolute;
      top: 145px;
      left: 257px;
      text-align: left;
      h1 {
        padding-bottom: 43px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      ul {
        margin-left: 20px;
      }
      ul li {
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        color: #ffffff;
        float: left;
        margin-right: 89px;
      }
    }

    .security_picture {
      position: absolute;
      top: 31px;
      right: 276px;
      img {
        width: 478px;
        height: 477px;
      }
    }
  }

  // 业务痛点
  .scene_park {
    background: #fff !important;
    padding: 60px 236px 23px 236px !important;
    .content {
      text-align: right;
    }
    p {
      width: auto !important;
    }

    img {
      max-width: 375px;
      max-height: 384px;
    }
  }

  .contentHit {
    padding-left: 85px;
  }

  //核心功能
  .content_space {
    background: #fafafa;
    padding: 60px 65px 122px 65px;
    h3 {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 37px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHeiLight;
      line-height: 32px;
      width: 208px;
      margin: auto;
    }
    .content {
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #000000;
        margin: 43px 0 44px 0;
      }
    }
  }
  .hexing h3 {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 50px;
  }

  .hexing img {
    max-width: 245px !important;
    max-height: 211px !important;
  }
}

@media only screen and (max-width: 1600px) {
  .main_content {
    .scene_top {
      margin-bottom: 0.7rem;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  metaInfo: {
    title: "智慧安防-WIDEN桅灯智能",
    meta: [
      {
        name: "keyWords",
        content:
          "智慧安防,桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
      },
      {
        name: "description",
        content:
          "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能智慧安防可实现智能监控、智能布防、数字巡逻。",
      },
    ],
  },
  data() {
    return {
      tabIndex: "2-4",
    };
  },
  methods: {},
  computed: {},
};
</script>